<template>
    <!-- 弹窗遮罩 -->
    <div class="lite_popup" v-show="show">
        <!-- 弹窗 -->
        <div class="lite_popup_box lite_popup_box_confirm">
            <!-- 标题栏 -->
            <div class="lite_popup_title">
                <!-- 标题 -->
                <span>{{ data.title }}</span>
                <!-- 关闭图标 -->
                <div class="icon white-close dialog-close" @click="show = false"></div>
            </div>
            <!-- 内容 -->
            <div class="lite_popup_content">
                <div>{{ data.desc }}</div>
            </div>
            <div class="lite_popup_footer">
                <!-- 按钮 -->
                <button ref="okBtn" @keyup.esc="show = false" @keyup.enter="ok" @click="ok">{{$t('language.common.ok')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            title: { type: String, default: 'Title' },
            desc: { type: String, default: 'Description content' },
        }
    },
    data() {
        return {
            show: false,
        };
    },
    watch: {
        show(val) {
            if (val) {
                this.$nextTick(() => {
                    this.$refs.okBtn.focus();
                });
            }
        }
    },
    methods: {
        ok() {
            this.show = false
            this.$emit('ok');
        },
    }
};
</script>

<style>
/* 弹窗宽度 */
.lite_popup_box.lite_popup_box_confirm {
    width: 620px;
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/lite_confirm.vue